import './contact_us';
import './contact_us.scss';
import {country_list_en} from './country_list_en.js';
import {country_list_ru} from './country_list_ru.js';

/* global selectedLocation */

$.fn.toggleAttr = function (name) {
  let $elem = $(this);
  if ($elem.attr(name)) {
    $elem.removeAttr(name);
  } else {
    $elem.attr(name, name);
  }
};

$('body').on('click', '[data-toggle-disabled]', function () {
  let $elem = $(this),
  target = $elem.data('toggle-disabled'),
  selector = `[data-id=${target}]`,
  $target = $(selector);
  $target.toggleAttr('disabled');
});

// footer form country autocomplete
// todo: short
var completeInputRu = document.querySelector(".js-complete-ru");
var completeInputEn = document.querySelector(".js-complete-en");

if (completeInputRu) {
  if (country_list_ru.includes(selectedLocation.title)) {
    completeInputRu.value = selectedLocation.title;
  }

  var completeRu = new Awesomplete(completeInputRu, { // eslint-disable-line
    maxItems: 300,
    sort: false,
    list: country_list_ru,
  });
  completeInputRu.addEventListener("focus", function(){
    completeRu.minChars = 0;
    completeRu.evaluate();
    completeRu.open();
  });
  completeInputRu.addEventListener("awesomplete-open", function(){
    $(".awesomplete").addClass("awesomplete--expanded");
  });
  completeInputRu.addEventListener("awesomplete-close", function(){
    $(".awesomplete").removeClass("awesomplete--expanded");
  });
}

if (completeInputEn) {
  if (country_list_en.includes(selectedLocation.title)) {
    completeInputEn.value = selectedLocation.title;
  }

  var completeEn = new Awesomplete(completeInputEn, { // eslint-disable-line
    maxItems: 300,
    sort: false,
    list: country_list_en,
  });
  completeInputEn.addEventListener("focus", function(){
    completeEn.minChars = 0;
    completeEn.evaluate();
    completeEn.open();
  });
  completeInputEn.addEventListener("awesomplete-open", function(){
    $(".awesomplete").addClass("awesomplete--expanded");
  });
  completeInputEn.addEventListener("awesomplete-close", function(){
    $(".awesomplete").removeClass("awesomplete--expanded");
  });
}
// eof footer form country autocomplete



// WEBPACK FOOTER //
// ./resources/views/partials/home/contact_us/contact_us.js